<template>
  <el-dialog
    :visible="visible"
    :show-close="false"
    width="60%"
    top="10vh"
    class="edit-detail-dialog"
    center
    @close="handleDialogClose"
    :close-on-click-modal="false">
    <span slot="title" class="title-container">
      <span class="title-text">{{factoryName + $t('factoryLabelHistory.labelEdit')}}</span>
      <img
        src="@/assets/close.png"
        class="close-image"
        @click="close"
      />
    </span>
    <el-form class="el-form" :model="form" ref="refForm" :rules="rules" label-width="120px">
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item label="P/N:" prop="partNo">
            <el-input
              v-model.trim="form.partNo"
              name="partNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.lotNo') + ':'" prop="lotNo">
            <el-input
              v-model.trim="form.lotNo"
              name="lotNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.count') + ':'" prop="qty">
            <el-input
              v-model.trim.number="form.qty"
              name="qty"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Tracking No:" prop="trackingNo">
            <el-input
              v-model.trim="form.trackingNo"
              name="trackingNo"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.binLevel') + ':'" prop="binLevel">
            <el-select
              filterable
              v-model.trim.number="form.binLevel"
              style="width: 100%;">
              <el-option
                v-for="(item, i) in passBinLevels"
                :key="i"
                :label="item.explain"
                :value="item.val">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('factoryLabelPrint.deliveryDate') + ':'" prop="dateCode">
            <el-date-picker
              v-model="form.dateCode"
              type="date"
              size="small"
              style="width: 100%;">
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.packageType') + ':'" prop="packageType">
            <el-input
              v-model.trim="form.packageType"
              name="packageType"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="Marking:" prop="marking">
            <el-input
              v-model.trim="form.marking"
              name="marking"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="64"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item v-if="isBoxLabel" label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.netWeight') + ':'" prop="netWeight">
            <el-input
              v-model.trim="form.netWeight"
              name="netWeight"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.grossWeight') + ':'" prop="grossWeight">
            <el-input
              v-model.trim="form.grossWeight"
              name="weight"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item label-width="0">
        <el-col :span="11">
          <el-form-item :label="$t('common.category') + ':'" prop="result">
            <el-radio-group v-model="form.result">
              <el-radio label="PASSED"></el-radio>
              <el-radio label="FAILED"></el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item :label="$t('common.identification') + ':'" prop="remark">
            <el-input
              v-model.trim="form.remark"
              name="remark"
              type="text"
              autocomplete="on"
              clearable
              size="small"
              maxlength="9"
            />
          </el-form-item>
        </el-col>
      </el-form-item>
      <el-form-item :label="$t('common.stylePreview') + ':'" style="margin-bottom: 0">
      </el-form-item>
      <el-form-item>
        <el-col :span="15">
          <iframe
            id="historyLabelIFrameShiXinLabelV2Dialog"
            scrolling="no"
            width="520"
            height="260"
            frameborder="0"
            style="background: #E9E9E9;"
          ></iframe>
          <el-button style="position: absolute; margin-left: 10px;" size="small" @click="printShiXinLabelFrame">{{$t('common.print')}}</el-button>
        </el-col>
      </el-form-item>
    </el-form>
    <span slot="footer">
        <el-button size="small" @click="close">{{$t('common.cancel')}}</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submitForm">
            {{$t('common.sure')}}
        </el-button>
      </span>
  </el-dialog>
</template>

<script>
  import moment from 'moment';
  import {
    validateCount,
    validateLotNo
  } from '@/utils/validate';
  import {
    initShiXinLabelV2Frame,
    printFactoryLabel,
  } from '@/utils/factory-label';
  import {
    updateBox,
  } from '@/api/boxLabel';
  import {
    updateLabel,
  } from '@/api/label';
  import {
    isValueEmpty,
    isNum,
    isPositiveNum
  } from '@/utils';
  import {
    generateBinLevelValue,
  } from '@/utils/label';
  import i18n from '@/lang';
  import {passBinLevels} from '@/utils/defines';

  export default {
    name: "ShiXinLabelV2Dialog",
    props: {
      factoryName: {
        type: String,
        default: '',
      },
      visible: {
        type: Boolean,
        default: false,
      },
      editRow: {
        type: Object,
        default: () => {},
      },
      isBoxLabel: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      const validateTrackingNo = (rule, value, callback) => {
        if (isValueEmpty(value)) {
          callback(new Error(i18n.t('validate.trackingNoCanNotBeEmpty')));
          return false;
        }
        if ((/^\d+$/.test(value))) {
          callback(new Error(i18n.t('validate.trackingNoCanNotBePureNumbers')));
          return false;
        }
        if (!(/^[A-Za-z0-9/$#@-]+#[A-Za-z0-9/$#@-]+/.test(value))) {
          callback(new Error(i18n.t('validate.trackingNoFormatIncorrect')));
          return false;
        }
        callback();
        return true;
      };
      const validateGrossWeight = (rule, value, callback) => {
        if (isValueEmpty(value)) {
          callback(new Error(i18n.t('validate.grossWeightCanNotBeEmpty')));
          return;
        }
        if (!isNum(value)) {
          callback(new Error(i18n.t('validate.grossWeightMustBeANumber')));
          return;
        }
        if (!isPositiveNum(value)) {
          callback(new Error(i18n.t('validate.grossWeightMustBeAPositiveNumber')));
          return;
        }
        callback();
      };
      const validateNetWeight = (rule, value, callback) => {
        if (isValueEmpty(value)) {
          callback(new Error(i18n.t('validate.netWeightCanNotBeEmpty')));
          return;
        }
        if (!isNum(value)) {
          callback(new Error(i18n.t('validate.netWeightMustBeANumber')));
          return;
        }
        if (!isPositiveNum(value)) {
          callback(new Error(i18n.t('validate.netWeightMustBeAPositiveNumber')));
          return;
        }
        callback();
      };
      return {
        form: {
          partNo: undefined,
          lotNo: undefined,
          qty: undefined,
          trackingNo: undefined,
          dateCode: undefined,
          packageType: undefined,
          result: 'PASSED',
          marking: undefined,
          grossWeight: undefined,
          netWeight: undefined,
          binLevel: 1,
          remark: '',
        },
        rules: {
          partNo: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.partNoCanNotBeEmpty')
          }],
          lotNo: [{
            required: true,
            trigger: 'blur',
            validator: validateLotNo
          }],
          qty: [{
            required: true,
            trigger: 'blur',
            validator: validateCount
          }],
          trackingNo: [{
            required: true,
            trigger: 'blur',
            validator: validateTrackingNo
          }],
          dateCode: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.deliveryDateCanNotBeEmpty')
          }],
          packageType: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.packageTypeCanNotBeEmpty')
          }],
          result: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.resultCanNotBeEmpty')
          }],
          marking: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.markingCanNotBeEmpty')
          }],
          grossWeight: [{
            trigger: 'blur',
            validator: validateGrossWeight
          }],
          netWeight: [{
            trigger: 'blur',
            validator: validateNetWeight
          }],
          binLevel: [{
            required: true,
            trigger: 'blur',
            message: this.$t('factoryLabelPrint.binLevelCanNotBeEmpty')
          }],
        },
        passBinLevels
      };
    },
    watch: {
      editRow(newValue) {
        if (newValue && Object.keys(newValue).length > 0 && this.visible === true) {
          const {
            id,
            chipName,
            partNo,
            lotNo,
            qty,
            trackingNo,
            dateCode,
            packageType,
            marking,
            grossWeight,
            netWeight,
            binLevel,
            reserve,
            customPartNo,
          } = newValue;
          this.form = {
            id,
            chipName,
            partNo: partNo,
            lotNo: lotNo,
            qty: qty,
            trackingNo: trackingNo,
            dateCode: dateCode,
            packageType: packageType,
            result: reserve,
            marking: marking,
            grossWeight: grossWeight,
            netWeight: netWeight,
            binLevel: binLevel,
            remark: customPartNo,
          };
          setTimeout(() => {
            this.initShiXinLabelV2Frame();
          }, 500);
        }
      }
    },
    methods: {
      handleDialogClose() {
        this.close();
      },
      close() {
        this.$emit('update:visible', false);
        this.$emit('close');
        if (this.$refs.refForm && typeof this.$refs.refForm.clearValidate === 'function') {
          this.$refs.refForm.clearValidate();
        }
      },
      submitForm() {
        this.$refs.refForm.validate(async (valid) => {
          if (valid) {
            if (this.isBoxLabel) {
              this.updateBox();
            } else {
              this.updateLabel();
            }
          }
        });
      },
      async updateBox() {
        const {
          id,
          partNo,
          lotNo,
          qty,
          trackingNo,
          dateCode,
          packageType,
          marking,
          grossWeight,
          netWeight,
          binLevel,
          result,
          remark,
        } = this.form;
        this.loading = true;
        try {
          await updateBox({
            boxLabelId: id,
            partNo,
            lotNo,
            qty,
            trackingNo,
            dateCode: moment(dateCode).format('YYYY-MM-DD'),
            packageType,
            marking,
            grossWeight: Number.parseFloat(grossWeight),
            netWeight: Number.parseFloat(netWeight),
            binLevel: binLevel,
            reserve: result,
            customPartNo: remark,
          });
          this.$emit('update');
          this.close();
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      async updateLabel() {
        const {
          id,
          partNo,
          lotNo,
          qty,
          trackingNo,
          dateCode,
          packageType,
          marking,
          binLevel,
          result,
          remark,
        } = this.form;
        this.loading = true;
        try {
          await updateLabel({
            labelId: id,
            partNo,
            lotNo,
            qty,
            trackingNo,
            dateCode: moment(dateCode).format('YYYY-MM-DD'),
            packageType,
            marking,
            binLevel: binLevel,
            reserve: result,
            customPartNo: remark,
          });
          this.$emit('update');
          this.close();
          this.$message({
            type: 'success',
            message: this.$t('common.updateSuccess'),
          });
        } catch (e) {
          // do nothing.
        } finally {
          this.loading = false;
        }
      },
      initShiXinLabelV2Frame() {
        const {
          chipName,
          partNo,
          lotNo,
          qty,
          trackingNo,
          dateCode,
          packageType,
          result,
          marking,
          grossWeight,
          netWeight,
          binLevel,
          remark,
        } = this.form;
        let binLevelValue = generateBinLevelValue({partNo, chipName, binLevel});
        let iframe = document.getElementById('historyLabelIFrameShiXinLabelV2Dialog');
        iframe = initShiXinLabelV2Frame({
          iframe,
          partNo,
          lotNo,
          qty,
          trackingNo,
          dateCode,
          packageType,
          result,
          marking,
          grossWeight,
          netWeight,
          binLevelExplain: binLevelValue,
          remark,
        });
        iframe.contentWindow.document.close();
      },
      printShiXinLabelFrame() {
        const {
          chipName,
          partNo,
          lotNo,
          qty,
          trackingNo,
          dateCode,
          packageType,
          result,
          marking,
          grossWeight,
          netWeight,
          binLevel,
          remark,
        } = this.form;
        let binLevelValue = generateBinLevelValue({partNo, chipName, binLevel});
        let iframe = document.getElementById('historyLabelIFrameShiXinLabelV2Dialog');
        iframe = initShiXinLabelV2Frame({
          iframe,
          partNo,
          lotNo,
          qty,
          trackingNo,
          dateCode,
          packageType,
          result,
          marking,
          grossWeight,
          netWeight,
          binLevelExplain: binLevelValue,
          remark,
        });
        iframe.contentWindow.document.close();
        printFactoryLabel(iframe);
      },
    }
  }
</script>

<style scoped>
  .title-container {
    display: flex;
    display: -webkit-flex;
    flex-direction: row;
    justify-content: space-between;
    background: -webkit-linear-gradient(#F9F9F9, #EEEEEE);
    background: -o-linear-gradient(#F9F9F9, #EEEEEE);
    background: -moz-linear-gradient(#F9F9F9, #EEEEEE);
    background: linear-gradient(#F9F9F9, #EEEEEE);
    padding: 10px 15px;
    align-items: center;
  }

  .title-text {
    color: #404040;
    font-size: 16px;
  }

  .el-form {
    margin: 0 30px;
  }

  .close-image {
    width: 22px;
    height: 22px;
    cursor: pointer;
    padding: 0 10px;
  }
</style>
<style>
  .edit-detail-dialog .el-dialog__header {
    padding: 0;
  }
</style>
